export const falsy = (obj, options) => {
  options = options || { ws: false }; // eslint-disable-line

  if (!!options.ws && !!obj && typeof obj === 'string') {
    return !!!obj.trim(); // eslint-disable-line
  }

  return !!!obj; // eslint-disable-line
};
